import { useEffect, useState } from "react";
import api from "@/lib/api";
import { HOME_POINT } from "@/lib/ui";

// User's home base, falling back to the default point until they set one.
export default function useHome() {
  const [home, setHome] = useState({ lat: HOME_POINT.lat, lng: HOME_POINT.lng, town: null, isDefault: true });
  useEffect(() => {
    api.get("/me/home").then((r) => {
      if (r.data?.lat) setHome({ lat: r.data.lat, lng: r.data.lng, town: r.data.town, isDefault: false });
    }).catch(() => {});
  }, []);
  return home;
}
